import type { C1_Room } from "./C1_Room";

/** Reparent native objects, preserving IDs, equipment subtrees, connections and undo tracking. */
export function transferRoomContents(source: C1_Room, target: C1_Room): void {
  if (!source.owner || !target.owner) return;
  for (const name of ["groups", "consumers", "buttons"] as const) {
    for (const object of [...(source.owner[name] ?? [])]) {
      source.owner[name].remove(object as never);
      object.parent = target.owner;
      target.owner[name].add(object as never);
    }
  }
}
